/* eslint-env: node */

const isSafari = () =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

export default isSafari
